<template>
	<section class="p-0">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col col-md-10 col-lg-8">
					<div class="nav nav-tabs mb-1">
						<router-link v-for="(item, index) in tabs"
								class="nav-item nav-link"
								activeClass="active"
								:to="item.href"
								:exact="item.href === '/profile'"
						>
							{{item.name}}
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: "ProfileNav",
		props: {
			tabs: {
				type: Array,
				required: true
			}
		},
		methods: {
			activeClass(index) {
				console.log(this.$route.path === this.tabs[index].href);
				return this.$route.path === this.tabs[index].href;
			}
		}
	}
</script>

<style scoped>

</style>
